import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('site-drawer', Component);

    const instances = ref([]);
    const activeRef = ref(null);

    const reserveScrollBarGap = () => {
      const body = document.getElementsByTagName('body')[0];
      const scrollbarWidth = window.innerWidth - document.documentElement.getBoundingClientRect().width;
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    const releaseScrollBarGap = () => {
      const body = document.getElementsByTagName('body')[0];
      body.style.paddingRight = null;
    }

    const disableScroll = () => {
      reserveScrollBarGap();
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = "hidden";
    }

    const enableScroll = () => {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = null;
      releaseScrollBarGap();
    }

    const getInstance = reference => {
      return instances.value.find(item => item.reference === reference);
    }

    const open = reference => {
      const instance = getInstance(reference);
      instance.open();
      activeRef.value = reference;

      disableScroll();
    }

    const close = reference => {
      const instance = getInstance(reference);
      instance.close();
      activeRef.value = null;

      enableScroll();
    }

    const toggle = reference => {
      const instance = getInstance(reference);

      if (instance.active) {
        close(reference);
      } else {
        open(reference);
      }
    }

    const siteDrawer = { instances, activeRef, open, close, toggle };
    app.config.globalProperties.$siteDrawer = siteDrawer;
    app.provide('$siteDrawer', siteDrawer);
  }
}